// extracted by mini-css-extract-plugin
export default {"btn":"DropdownSelect-module__btn--Ufhfs"};